module.exports = __webpack_public_path__ + "static/media/logo_colorstack.95e9a7d3.png";